import { cpf as cpfValidator } from 'cpf-cnpj-validator';
import { z } from 'zod';

export const minPasswordLength = 8;

export const passwordSchema = z
  .string()
  .min(minPasswordLength, { message: 'Nome deve conter mais de 8 caracteres' })
  .refine((value) => /[0-9]/.test(value))
  .refine((value) => /[a-z]/.test(value))
  .refine((value) => /[A-Z]/.test(value))
  .refine((value) => /[$&+,:;=?@#|'<>.^*()%!-]/.test(value), {
    message: 'A senha não atende aos requisitos mínimos',
  });

export const updatePasswordSchema = z
  .string()
  .refine((value) => !value || value.length >= minPasswordLength, {
    message: `A senha deve conter pelo menos ${minPasswordLength} caracteres`,
  })
  .refine((value) => !value || /[0-9]/.test(value), {
    message: 'A senha deve conter pelo menos um número',
  })
  .refine((value) => !value || /[a-z]/.test(value), {
    message: 'A senha deve conter pelo menos uma letra minúscula',
  })
  .refine((value) => !value || /[A-Z]/.test(value), {
    message: 'A senha deve conter pelo menos uma letra maiúscula',
  })
  .refine((value) => !value || /[$&+,:;=?@#|'<>.^*()%!-]/.test(value), {
    message: 'A senha deve conter pelo menos um caractere especial',
  });

export const resetPasswordSchema = z
  .object({
    password: passwordSchema,
    passwordConfirmation: z
      .string()
      .min(minPasswordLength, { message: 'A senha deve conter pelo menos 8 caracteres' }),
  })
  .refine((data) => data.password === data.passwordConfirmation, {
    message: 'As senhas devem coincidir.',
    path: ['passwordConfirmation'],
  });

export const colorSchemeParser = z
  .enum(['light', 'dark', 'environment'])
  .default('environment')
  .catch('environment');

export const forgotPasswordSchema = z.object({
  email: z.string().email({ message: 'Email inválido!' }),
});

export const otpTokenSchema = z.object({
  otpToken: z.string().regex(/^\d{6}$/, 'Digite os 6 dígitos do código'),
});

export const organizerReceiptSchema = z.object({
  email: z.string().email({ message: 'Email inválido!' }),
});

export const organizerEmailSchema = z.object({
  organizerId: z.string(),
});

export const editUserProfileSchema = z
  .object({
    name: z.string().min(3),
    lastPassword: updatePasswordSchema.optional().or(z.literal('')),
    password: updatePasswordSchema.optional().or(z.literal('')),
    passwordConfirmation: z.string().optional().or(z.literal('')),
  })
  .refine(
    (data) => {
      if (data.password || data.passwordConfirmation) {
        return data.password === data.passwordConfirmation;
      }
      return true; // Se ambos forem opcionais, não precisa validar
    },
    {
      message: 'As senhas devem coincidir.',
      path: ['passwordConfirmation'],
    }
  );

export const createAccountSchema = z
  .object({
    name: z.string().min(3, { message: 'Nome deve conter mais de 3 caracteres' }),
    cpf: z
      .string()
      .optional()
      .refine((value) => !value || cpfValidator.isValid(value), {
        message: 'CPF inválido',
      }),
    isForeign: z.boolean().optional(),
    email: z.string().email({ message: 'Email Inválido' }),
    password: passwordSchema,
    passwordConfirmation: z
      .string()
      .min(minPasswordLength, { message: 'A senha deve conter pelo menos 8 caracteres' }),
  })
  .refine((data) => data.password === data.passwordConfirmation, {
    message: 'As senhas devem coincidir.',
    path: ['passwordConfirmation'],
  });
